module.exports = __webpack_public_path__ + "img/xinhu_template_2.24b5f128.png";